import { render } from "./EnterSmsCodeForm.vue?vue&type=template&id=64116d60"
import script from "./EnterSmsCodeForm.vue?vue&type=script&lang=js"
export * from "./EnterSmsCodeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__